<template>
  <div v-if="pageContext.data.page" class="bg-white border-t border-gray-200 py-8">
    <div class="max-w-[1400px] mx-auto px-6">
      <div class="">
        <div>
          <div class="flex items-center gap-2 mb-4"><MapPin :size="20" class="text-brand" /><h3 class="font-semibold text-gray-900">{{ t('sections.nearbyNeighborhoods') }}</h3></div>
          <div class="grid grid-cols-2 space-y-2 text-sm">
            <div v-for="page of pageContext.data.page?.children ?? []" :key="page.path" class="">
              <a :href="'/' + page.path + '/search'" class="text-gray-600 hover:text-brand">
                {{ getAddressPart(page) }} {{ t('searchResults.properties') }}
              </a>
            </div>
          </div>
        </div>
        <!-- Add other columns similarly -->
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { MapPin } from 'lucide-vue-next';
import { usePageContext } from "vike-vue/usePageContext";

import { useAddress } from '..//composables/address'
const { getAddressPart } = useAddress()

import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const pageContext = usePageContext();
</script>
